module.exports = __webpack_public_path__ + "static/media/28DGC8.bf2d3f1d.jpg";